module.exports = __webpack_public_path__ + "static/img/20230320174811.f3440c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20230320174811.png
// module id = 0v+h
// module chunks = 1